module.exports = __webpack_public_path__ + "img/about2-mob.52561d48.jpg";